import EntryActionTypes from '../constants/EntryActionTypes';

const fetchMonthlyReportInCurrentBoard = (year, month, listId) => ({
  type: EntryActionTypes.MONTHLY_REPORT_IN_CURRENT_BOARD_FETCH,
  payload: {
    year,
    month,
    listId,
  },
});

export default {
  fetchMonthlyReportInCurrentBoard,
};

